import { http } from '@/app/lib/http/client'

export interface DashboardKpi {
  title: string
  value: string
  change: string
  trend: 'up' | 'down' | 'neutral'
}

export interface DashboardSalesDataItem {
  day: string
  ventas: number
  utilidad: number
}

export interface DashboardBranchComparisonItem {
  sucursal: string
  ventas: number
  utilidad: number
}

export interface DashboardCriticalAlert {
  id: number
  type: string
  product: string
  branch: string
  stock?: number
  days?: number
  severity: 'high' | 'medium' | 'low'
}

export interface DashboardRecentActivity {
  id: number
  type: string
  description: string
  subject: string
  user: string
  time: string
}

export interface DashboardData {
  kpis: DashboardKpi[]
  salesData: DashboardSalesDataItem[]
  branchComparison: DashboardBranchComparisonItem[]
  criticalAlerts: DashboardCriticalAlert[]
  recentActivity: DashboardRecentActivity[]
}

export const dashboardService = {
  async getDashboard(): Promise<DashboardData> {
    const response = await http.get('/sucursales/current/dashboard')
    return response.data.data
  },
}
